/* Hero 2026 — slider accesible con autoplay, swipe y soporte del editor de temas */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Hero26(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero26-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero26-dot]'));
    this.count = root.querySelector('[data-hero26-count]');
    this.index = 0;
    this.total = this.slides.length;
    this.speed = parseInt(root.dataset.speed, 10) || 6000;
    this.autoplayEnabled = root.dataset.autoplay === 'true' && !REDUCED_MOTION.matches && this.total > 1;
    this.rafId = null;
    this.startTime = null;
    this.paused = false;

    if (this.total <= 1) return;
    this.bind();
    if (this.autoplayEnabled) this.play();
  }

  Hero26.prototype.bind = function () {
    var self = this;

    var prev = this.root.querySelector('[data-hero26-prev]');
    var next = this.root.querySelector('[data-hero26-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1, true); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1, true); });

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.goTo(i, true); });
    });

    // Pausa cuando el usuario interactúa o la pestaña no está visible
    this.root.addEventListener('mouseenter', function () { self.pause(); });
    this.root.addEventListener('mouseleave', function () { self.resume(); });
    this.root.addEventListener('focusin', function () { self.pause(); });
    this.root.addEventListener('focusout', function () { self.resume(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.pause();
      else self.resume();
    });

    // Swipe táctil
    var viewport = this.root.querySelector('[data-hero26-viewport]');
    var startX = null;
    var startY = null;
    viewport.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
    });
    viewport.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        self.goTo(dx < 0 ? self.index + 1 : self.index - 1, true);
      }
    });

    // Teclado
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') self.goTo(self.index - 1, true);
      if (e.key === 'ArrowRight') self.goTo(self.index + 1, true);
    });
  };

  Hero26.prototype.goTo = function (i, byUser) {
    var target = ((i % this.total) + this.total) % this.total;
    if (target === this.index) {
      if (byUser) this.restartTimer();
      return;
    }

    this.slides[this.index].classList.remove('is-active');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.dots[this.index].classList.remove('is-active');
    this.dots[this.index].setAttribute('aria-selected', 'false');
    this.dots[this.index].classList.toggle('is-done', target > this.index);

    this.index = target;

    this.slides[this.index].classList.add('is-active');
    this.slides[this.index].removeAttribute('aria-hidden');
    this.dots[this.index].classList.add('is-active');
    this.dots[this.index].setAttribute('aria-selected', 'true');

    this.dots.forEach(function (dot, n) {
      dot.classList.toggle('is-done', n < target);
      if (n !== target) dot.style.setProperty('--h26-fill', '0%');
    });

    if (this.count) {
      this.count.textContent = String(this.index + 1).padStart(2, '0') + ' / ' + String(this.total).padStart(2, '0');
    }

    this.restartTimer();
  };

  Hero26.prototype.play = function () {
    var self = this;
    this.startTime = null;
    var step = function (ts) {
      if (self.paused) return;
      if (self.startTime === null) self.startTime = ts;
      var progress = Math.min((ts - self.startTime) / self.speed, 1);
      self.dots[self.index].style.setProperty('--h26-fill', (progress * 100).toFixed(1) + '%');
      if (progress >= 1) {
        self.goTo(self.index + 1, false);
        return;
      }
      self.rafId = requestAnimationFrame(step);
    };
    this.rafId = requestAnimationFrame(step);
  };

  Hero26.prototype.pause = function () {
    this.paused = true;
    if (this.rafId) cancelAnimationFrame(this.rafId);
  };

  Hero26.prototype.resume = function () {
    if (!this.autoplayEnabled || !this.paused) return;
    this.paused = false;
    this.startTime = null;
    this.play();
  };

  Hero26.prototype.restartTimer = function () {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (!this.autoplayEnabled || this.paused) return;
    this.startTime = null;
    this.play();
  };

  Hero26.prototype.destroy = function () {
    if (this.rafId) cancelAnimationFrame(this.rafId);
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hero26]').forEach(function (el) {
      if (el.hero26Instance) el.hero26Instance.destroy();
      el.hero26Instance = new Hero26(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Soporte del editor de temas de Shopify
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('[data-hero26]');
    if (!section || !section.hero26Instance) return;
    var slide = e.target.closest('[data-hero26-slide]');
    if (!slide) return;
    var idx = Array.prototype.indexOf.call(section.querySelectorAll('[data-hero26-slide]'), slide);
    if (idx >= 0) {
      section.hero26Instance.pause();
      section.hero26Instance.goTo(idx, true);
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var section = e.target.closest('[data-hero26]');
    if (section && section.hero26Instance) section.hero26Instance.resume();
  });
})();
